import { useFindProfile } from '@hooks/profile'
import { IGenericTask } from '@interfaces/task/generic/IGenericTask'
import { api } from '@services/apiClient'

interface IPatchTaskParams {
  id: number
  changes: Partial<IGenericTask>
}

export function usePatchTask() {
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  async function patchTask({ id, changes }: IPatchTaskParams) {
    const url = `/sites/${siteId}/tasks/${id}`

    const { data } = await api.patch<IGenericTask>(url, changes)

    return data
  }

  return { patchTask }
}
